var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlane = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75727 8.54557C9.77213 8.35669 10.0656 8.42239 10.0656 8.42239L17.1245 10.1005C17.1245 9.44347 16.9833 9.37504 16.7752 9.26006L9.99133 5.67394C9.99133 5.67394 9.80928 4.03144 9.80928 2.5833C9.80928 1.91261 9.37089 0.445312 8.80247 0.445312C8.23405 0.445312 7.79565 1.93451 7.79565 2.5833C7.79565 3.95752 7.61361 5.67394 7.61361 5.67394L0.829696 9.26006C0.565918 9.39694 0.480469 9.47085 0.480469 10.1005L7.53559 8.42239C7.53559 8.42239 7.82909 8.35669 7.84395 8.54557C7.85881 8.73446 7.79937 10.4372 8.06315 11.3406C8.09658 11.461 7.97027 11.4692 7.88482 11.5431L5.95664 12.441C5.89348 12.493 5.86376 12.6409 5.86376 12.6409L5.82661 13.1473L8.79875 12.2713L11.7709 13.1473L11.7337 12.6409C11.7375 12.6409 11.7077 12.493 11.6446 12.441L9.7164 11.5431C9.63095 11.4692 9.50464 11.461 9.53807 11.3406C9.79442 10.4372 9.74241 8.73446 9.75727 8.54557Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plane.f618d972af0aa57b89ad644ef051fb08.svg";